import { HttpStatusCode } from '@angular/common/http';

import { ApiEndpoint } from '../api';

export const DEFAULT_TIME_OFFSET_SECONDS = 30;
export const CSRF_HEADER_NAME = 'X-CSRF-Token';

export const CRSF_EXCLUDED_ENDPOINTS = [
  ApiEndpoint.Crsf,
  ApiEndpoint.OAuthLogin,
];

/**
 * session-manager endpoints (relative to `environment.auth.sessionManagerHost`)
 */
export const SessionManagerEndpoint = {
  /**
   * Keycloak login with an IdP hint. session-manager calls it "google", but the hinted
   * alias is configurable (`KEYCLOAK_GOOGLE_IDP_ALIAS`), so it can point at JumpCloud
   */
  CorporateSsoLogin: 'auth/login/google',
  Login: 'auth/login',
  Logout: 'auth/logout',
} as const;

export const SESSION_REFRESH_HEADER_NAME = 'Session-Refresh';
export const SESSION_REFRESH_DISABLED_VALUE = '0';

/**
 * session-manager answers a failed token refresh with 400 `INVALID_INPUT` (`details: "...session expired"`)
 * instead of 401, after clearing its session cookie
 */
export const SESSION_MANAGER_INVALID_INPUT_CODE = 'INVALID_INPUT';
export const SESSION_MANAGER_SESSION_EXPIRED_DETAILS = 'session expired';

/**
 * The auth backend was not reached: `0` is a network/CORS failure, 502/503/504 come from the
 * proxy in front of an unavailable service
 */
export const SERVICE_UNREACHABLE_STATUS_CODES: readonly number[] = [
  0,
  HttpStatusCode.BadGateway,
  HttpStatusCode.ServiceUnavailable,
  HttpStatusCode.GatewayTimeout,
];

export const SignInMethod = {
  CorporateSso: 'corporate-sso',
  Credentials: 'credentials',
} as const;

export const SignInQueryParam = {
  Reason: 'reason',
} as const;

export const SignInReason = {
  SessionExpired: 'session-expired',
} as const;
